export default "__VITE_ASSET__85653cfc__"